import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { FormattedMessage } from 'react-intl'
import { Modal, ModalActions } from 'components/Modal/Modal'
import { Form, FormGroup, Label } from 'reactstrap'
import ZoneSelect from 'components/ZoneSelect/ZoneSelect'
import { selectAvailableZones } from 'store/global'
import { setModalDisplayed } from 'store/settings'
import messages from './messages'
import styles from './SettingsModal.scss'

interface FormField {
  key: string
  isDisplayed?: boolean
  label: React.ReactNode
  renderInput?: () => React.ReactNode
}

interface FormAction {
  key: string
  outline?: boolean
  label: string
  onClick: () => void
}

const SettingsModal: React.FC = () => {
  const dispatch = useDispatch()

  const onClose = () => dispatch(setModalDisplayed({ isDisplayed: false }))

  const availableZones = useSelector(selectAvailableZones)
  const allowZoneSelection = availableZones.length > 0

  const renderHeader = () => (
    <header className={styles.header}>
      <FormattedMessage {...messages.header} />
    </header>
  )

  const formActions: FormAction[] = [
    {
      key: 'cancel',
      outline: true,
      label: 'Close',
      onClick: onClose,
    },
  ]

  const fields: Record<string, FormField> = {
    selectedZone: {
      key: 'selectedZone',
      isDisplayed: allowZoneSelection,
      label: 'Current Zone',
      renderInput: () => <ZoneSelect />,
    },
  }

  return (
    <Modal isOpen size='lg' onClose={onClose} header={renderHeader()}>
      <Form className={styles.container}>
        {Object.values(fields)
          .filter(({ isDisplayed = true }) => isDisplayed)
          .map(({ key, label, renderInput = () => null }) => (
            <FormGroup key={key} className={styles.group}>
              <Label for={key} className={styles.label}>
                {label}
              </Label>
              {renderInput()}
            </FormGroup>
          ))}
        <ModalActions actions={formActions} />
      </Form>
    </Modal>
  )
}

export default SettingsModal
